import { Subject } from 'rxjs';
import { Transport } from 'src/tmc-yard/common/model/transport.model';

export enum StationStyle {

  used,
  available,
  assignable,
  locked,
  waitingarea

}

export enum RoutingOptionReferenceType {
  WORKING_AREA = 'WORKING_AREA', WAITING_AREA = 'WAITING_AREA', STATION_SET = 'STATION_SET'
}

export enum RoutingOptionType {
  NEXT_STATION = 'NEXT_STATION', //
  RESTART_ROUTE = 'RESTART_ROUTE', //
  SELECT_STATION = 'SELECT_STATION', //
  FORWARD_TO_PROCESS = 'FORWARD_TO_PROCESS', //
  FINISH_ROUTE = 'FINISH_ROUTE', //
  WAITING_FOR_RETRIEVE = 'WAITING_FOR_RETRIEVE', //
  WAITING_FOR_PULLING = 'WAITING_FOR_PULLING', //
  CREATE_MOVING_ORDER = 'CREATE_MOVING_ORDER', //
  PLAN_ASSIGNMENT = 'PLAN_ASSIGNMENT' //
}

export class RoutingOption {
  label: string;
  dictionaryKey: string;
  routingOptionType: RoutingOptionType;
  style: string;
  referenceType: RoutingOptionReferenceType;
  refrence: number;

  constructor(routingOption: RoutingOption) {
    this.update(routingOption);
  }

  public update(routingOption: RoutingOption) {
    this.label = routingOption?.label;
    this.dictionaryKey = routingOption?.dictionaryKey;
    this.routingOptionType = routingOption?.routingOptionType;
    this.style = routingOption?.style;
    this.referenceType = routingOption?.referenceType;
    this.refrence = routingOption?.refrence;
  }
}

export class TransportCreationProfileGroup {
  id: number;
  displayName: string;
  index: number;
  transportCreationProfiles = new Array<TransportCreationProfile>();
  
  constructor(reference: Partial<TransportCreationProfileGroup>) {
    this.update(reference);
  }

  update(profileGroup: Partial<TransportCreationProfileGroup>) {
    this.id = profileGroup.id;
    this.displayName = profileGroup.displayName;
    if (profileGroup.transportCreationProfiles != null) {
      for (let i = 0; i < profileGroup.transportCreationProfiles.length; i++) {
        const newTransportCreationProfile = profileGroup.transportCreationProfiles[i];
        if (i < this.transportCreationProfiles.length) {
          this.transportCreationProfiles[i].update(newTransportCreationProfile);
        } else {
          this.transportCreationProfiles.push(new TransportCreationProfile(newTransportCreationProfile));
        }
      }
      if (profileGroup.transportCreationProfiles.length < this.transportCreationProfiles.length) {
        this.transportCreationProfiles.splice(profileGroup.transportCreationProfiles.length, this.transportCreationProfiles.length);
      }
    } else {
      this.transportCreationProfiles = new Array<TransportCreationProfile>();
    }
  }
}

export class TransportCreationProfile {
  id: number;
  displayName: string;
  numberPlateList: boolean;
	actionTablet: boolean;
	qrCode: boolean;

  constructor(reference: TransportCreationProfile) {
    this.update(reference);
  }

  update(reference: TransportCreationProfile) {
    this.id = reference.id;
    this.displayName = reference.displayName;
    this.actionTablet = reference.actionTablet === true;
    this.numberPlateList = reference.numberPlateList === true;
    this.qrCode = reference.qrCode === true;
  }
}

export enum MovementOrderProcessingStatus {
  OPEN = 'OPEN', STARTED = 'STARTED', MOVEMENT_STARTED = 'MOVEMENT_STARTED', MOVEMENT_COMPLETED = 'MOVEMENT_COMPLETED', COMPLETED = 'COMPLETED', CANCELED = 'CANCELED'
}

export enum CompletionOptionType {
  NO_FURTHER_PROCESSING = 'NO_FURTHER_PROCESSING', COMPLETE_ON_WAITING_AREA = 'COMPLETE_ON_WAITING_AREA', FORWARD_TO_NEXT_PROCESSING_STATION = 'FORWARD_TO_NEXT_PROCESSING_STATION'
}

export class CompletionOption {

  type: CompletionOptionType;
  targetStationId: number;
  targetStationSetId: number;

  constructor(completionOption: any) {
    this.type = completionOption.type;
    this.targetStationId = completionOption.targetStationId;
    this.targetStationSetId = completionOption.targetStationSetId;
  }
}

export class StationUsage {

  stationId: number;
  faulty: boolean;

  // TODO YARD-3293
  selectedOption: RoutingOption;

  style: StationStyle;
  css: string;
  icons = new Array<string>();

  transports = new Array<Transport>();

  // Stationsstatus
  transportsAvailable: boolean;
  disabled: boolean;
  suspended: boolean;
  suspendedSince: number;
  suspensionCritcal: boolean;
  note: string;
  ongoingMovementFromStation: boolean;
  ongoingMovementToStation: boolean;
  ongoingMovementProcessingStatus: MovementOrderProcessingStatus;

  // Attribute zur Transportsteuerung auf der Station
  cancelAllowed: boolean;
  changeProcessingStatusAllowed: boolean;
  changeProcessingStatusNextAllowed: boolean;
  completeAssigmentAllowed: boolean;
  createMovementOrderAllowed: boolean;
  processingStatusModel: string;
  processingStatusModelValue: string;
  messageKeys = new Array<string>();
  routingOptions = new Array<RoutingOption>();
  transportDetailsAllowed: boolean;
  linkTransportsAllowed: boolean;
  umbrueckenAllowed: boolean;
  attachDetachTransportsAllowed: boolean;
  sendMessageAllowed: boolean;

  defaultCompletionOption: CompletionOption;

  changed = new Subject<boolean>();

  plannedTransportAssignmentPossible: boolean;
  createMovementOrderPossible: boolean;
  requiresLoadingZone: boolean;
  loadingZoneLock: boolean;

  availableLoadingZones = new Array<LoadingZoneReference>();

  transportCreationProfileGroups = new Array<TransportCreationProfileGroup>();

  constructor(stationUsage: any) {
    this.stationId = stationUsage?.stationId;
    this.updateStationUsageDetails(stationUsage);
  }

  updateStationUsageDetails(stationUsage: Partial<StationUsage>) {

    this.faulty = stationUsage.faulty;

    this.plannedTransportAssignmentPossible = stationUsage.plannedTransportAssignmentPossible;
    this.createMovementOrderPossible = stationUsage.createMovementOrderPossible;

    this.transportsAvailable = stationUsage.transportsAvailable;
    this.disabled = stationUsage.disabled;
    this.suspended = stationUsage.suspended;
    this.suspendedSince = stationUsage.suspendedSince;
    this.suspensionCritcal = stationUsage.suspensionCritcal;
    this.note = stationUsage.note;
    this.ongoingMovementFromStation = stationUsage.ongoingMovementFromStation;
    this.ongoingMovementToStation = stationUsage.ongoingMovementToStation;
    this.ongoingMovementProcessingStatus = stationUsage.ongoingMovementProcessingStatus;

    this.cancelAllowed = stationUsage.cancelAllowed;
    this.changeProcessingStatusAllowed = stationUsage.changeProcessingStatusAllowed;
    this.changeProcessingStatusNextAllowed = stationUsage.changeProcessingStatusNextAllowed;
    this.completeAssigmentAllowed = stationUsage.completeAssigmentAllowed;
    this.createMovementOrderAllowed = stationUsage.createMovementOrderAllowed;
    this.sendMessageAllowed = stationUsage.sendMessageAllowed;

    this.processingStatusModel = stationUsage.processingStatusModel;
    this.processingStatusModelValue = stationUsage.processingStatusModelValue;

    this.transportDetailsAllowed = stationUsage.transportDetailsAllowed;
    this.linkTransportsAllowed = stationUsage.linkTransportsAllowed;
    this.umbrueckenAllowed = stationUsage.umbrueckenAllowed;
    this.attachDetachTransportsAllowed = stationUsage.attachDetachTransportsAllowed;

    this.messageKeys = new Array<string>();
    if (stationUsage.messageKeys != null) {
      this.messageKeys.push(...stationUsage.messageKeys);
    }

    if (stationUsage.defaultCompletionOption != null) {
      this.defaultCompletionOption = new CompletionOption(stationUsage.defaultCompletionOption);
    }

    if (stationUsage.routingOptions != null) {
      for (let i = 0; i < stationUsage.routingOptions.length; i++) {
        const newRoutingOption = stationUsage.routingOptions[i];
        if (i < this.routingOptions.length) {
          this.routingOptions[i].update(newRoutingOption);
        } else {
          this.routingOptions.push(new RoutingOption(newRoutingOption));
        }
      }
      if (stationUsage.routingOptions.length < this.routingOptions.length) {
        this.routingOptions.splice(stationUsage.routingOptions.length, this.routingOptions.length);
      }
    } else {
      this.routingOptions = new Array<RoutingOption>();
    }


    if (stationUsage.transports != null) {
      for (let i = 0; i < stationUsage.transports.length; i++) {
        const newTransport = stationUsage.transports[i];
        if (i < this.transports.length) {
          this.transports[i].update(newTransport);
        } else {
          this.transports.push(new Transport(newTransport));
        }
      }
      if (stationUsage.transports.length < this.transports.length) {
        this.transports.splice(stationUsage.transports.length, this.transports.length);
      }
    } else {
      this.transports = new Array<Transport>();
    }

    this.style = stationUsage.style;
    if (stationUsage.icons) {
      for (const icon of stationUsage.icons) {
        this.icons.push(icon);
      }
    }

    if (this.routingOptions != null) {
      if (this.routingOptions.indexOf(this.selectedOption) === -1) {
        this.selectedOption = this.routingOptions[0];
      }
    }

    const availableLoadingZones = new Array<LoadingZoneReference>();
    if (stationUsage.availableLoadingZones != null) {
      for (const loadingZone of stationUsage.availableLoadingZones) {
        availableLoadingZones.push(new LoadingZoneReference({
          id: loadingZone.id,
          name: loadingZone.name,
          priority: loadingZone.priority
        }));
      }
    }
    this.availableLoadingZones = availableLoadingZones;
    this.requiresLoadingZone = stationUsage.requiresLoadingZone;
    this.loadingZoneLock = stationUsage.loadingZoneLock;

    if (stationUsage.transportCreationProfileGroups != null) {
      for (let i = 0; i < stationUsage.transportCreationProfileGroups.length; i++) {
        const newTransportCreationProfileGroup = stationUsage.transportCreationProfileGroups[i];
        if (i < this.transportCreationProfileGroups.length) {
          this.transportCreationProfileGroups[i].update(newTransportCreationProfileGroup);
        } else {
          this.transportCreationProfileGroups.push(new TransportCreationProfileGroup(newTransportCreationProfileGroup));
        }
      }
      if (stationUsage.transportCreationProfileGroups.length < this.transportCreationProfileGroups.length) {
        this.transportCreationProfileGroups.splice(stationUsage.transportCreationProfileGroups.length, this.transportCreationProfileGroups.length);
      }
    } else {
      this.transportCreationProfileGroups = new Array<TransportCreationProfileGroup>();
    }

    // TODO StationDetails auf Styles umbauen?
    this.setCss();
  }

  setCss() {
    this.icons = new Array<string>();
    if (this.transportsAvailable) {
      this.icons.push('transport-available fa-light fa-truck');
    }

    switch (this.style) {
      case StationStyle.used: this.css = 'used'; break;
      case StationStyle.available: this.css = 'available'; break;
      case StationStyle.assignable: this.css = 'assignable'; break;
      case StationStyle.locked: this.css = 'locked'; break;
      case StationStyle.waitingarea: this.css = 'waitingarea'; break;
      default: this.css = ''; break;
    }
  }
}

export class LoadingZoneReference {

  id: number;
  name: string;
  priority: string;

  constructor(loadingZone?: any) {
    if (loadingZone != null) {
      this.id = loadingZone.id;
      this.name = loadingZone.name;
      this.priority = loadingZone.priority;
    }
  }
}
